/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Schedule_Add_TimeInputs */

const vi_irrigation_schedule_add_time = /** @type {(inputs: Irrigation_Schedule_Add_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm giờ`)
};

/**

* @param {Irrigation_Schedule_Add_TimeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_schedule_add_time = /** @type {((inputs?: Irrigation_Schedule_Add_TimeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Schedule_Add_TimeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_schedule_add_time(inputs)
});